export const GET_STARTUP_PAGE_ATTEMPT = 'GET_STARTUP_PAGE_ATTEMPT';
export const GET_STARTUP_PAGE_FAILURE = 'GET_STARTUP_PAGE_FAILURE';
export const GET_STARTUP_PAGE_SUCCESS = 'GET_STARTUP_PAGE_SUCCESS';
export const CANNOT_INVEST_ATTEMPT = 'CANNOT_INVEST_ATTEMPT';
export const CANNOT_INVEST_SUCCESS = 'CANNOT_INVEST_SUCCESS';
export const CANNOT_INVEST_FAILURE = 'CANNOT_INVEST_FAILURE';

export const CLEAR_STARTUP_PAGE_ERROR = 'CLEAR_STARTUP_PAGE_ERROR';
export const CLEAR_STATE = 'CLEAR_STATE';
